import type React from 'react';
import { useLabResultViewStore } from '../../../store/useLabResultViewStore.ts';
import { BefundViewContent } from './BefundViewContent.tsx';
import { useBefundDetailsStyles } from './useBefundDetailsStyles.ts';

export const BefundView: React.FC<{
  myLabIdentifiers: string[] | undefined;
  deemphasizePathological?: boolean;
}> = ({ myLabIdentifiers, deemphasizePathological }) => {
  const selectedId = useLabResultViewStore(state => state.selectedId);
  const styles = useBefundDetailsStyles(!!selectedId);

  return (
    <div className={styles.layout}>
      <BefundViewContent key={selectedId} myLabIdentifiers={myLabIdentifiers} deemphasizePathological={deemphasizePathological} />
    </div>
  );
};
